<template>
  <div class="bill-detail-page">
    <!-- 顶部工具栏 -->
    <div class="top-toolbar">
      <div class="breadcrumb">
        <el-button 
          type="text" 
          @click="goBack" 
          class="back-button"
          size="small"
        >
          <el-icon><ArrowLeft /></el-icon>
          返回
        </el-button>
        <span class="breadcrumb-text">账单详情{{ routeParams.month ? ` - ${routeParams.month}` : '' }}</span>
      </div>

    </div>


    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 图表区域 - 整体容器 -->
      <div class="charts-section">
        <!-- 左侧饼图区域 -->
        <div class="left-charts">
          <div class="chart-item">
            <div class="pie-chart-header">服务费用占比</div>
            <div ref="pieChart" class="pie-chart"></div>
            <div class="pie-info">
              <div class="pie-stats">
                <div 
                  class="stat-item charge"
                  :class="{ active: selectedStatType === 'charge' }"
                  @click="switchStatType('charge')"
                >
                  <div class="stat-label">Charge:</div>
                  <div class="stat-value">{{ currencySymbol }}{{ statsData.charge }}</div>
                </div>
                <div 
                  class="stat-item cost"
                  :class="{ active: selectedStatType === 'cost' }"
                  @click="switchStatType('cost')"
                >
                  <div class="stat-label">实际花费:</div>
                  <div class="stat-value">{{ currencySymbol }}{{ statsData.cost }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- 右侧柱状图区域 -->
        <div class="right-content">
          <div class="entity-cost-header">
            <span class="entity-cost-title">子实体费用</span>
            <div class="entity-cost-actions">
              <el-button
                size="small"
                :type="entityCostVisibility.charge ? 'primary' : ''"
                @click="toggleEntityCost('charge')"
              >
                Charge
              </el-button>
              <el-button
                size="small"
                :type="entityCostVisibility.totalCost ? 'warning' : ''"
                @click="toggleEntityCost('totalCost')"
                class="orange-button"
              >
                实际花费
              </el-button>
            </div>
          </div>
          <div class="bar-chart-container">
            <div ref="barChart" class="bar-chart"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 实体统计表格 -->
    <div class="entity-stats-section">
      <div class="section-header">
        <h3>link费用统计</h3>
      </div>
      <div class="stats-table-container">
        <el-table 
          :data="entityStatsData" 
          style="width: 100%"
          :show-header="true"
          size="small"
          max-height="400"
        >
          <el-table-column prop="linkId" label="LinkId" align="center" min-width="130"></el-table-column>
          <el-table-column prop="linkName" label="客户名称" align="center" min-width="120"></el-table-column>
          <el-table-column prop="payerName" label="Payer Name" align="center" min-width="120"></el-table-column>
          <el-table-column label="类别" align="center" min-width="80">
            <template #default="scope">AWS</template>
          </el-table-column>
          <el-table-column prop="month" label="账单年月" align="center" min-width="100">
            <template #default="scope">{{ routeParams.month }}</template>
          </el-table-column>
          <el-table-column prop="charge" label="Charge" align="center" min-width="110">
            <template #default="scope">{{ currencySymbol }}{{ scope.row.charge.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="discount" label="Discount" align="center" min-width="110">
            <template #default="scope">{{ currencySymbol }}{{ scope.row.discount.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="tax" label="Tax" align="center" min-width="100">
            <template #default="scope">{{ currencySymbol }}{{ scope.row.tax.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="totalCost" label="TotalCost" align="center" min-width="110">
            <template #default="scope">{{ currencySymbol }}{{ scope.row.totalCost.toFixed(2) }}</template>
          </el-table-column>
        </el-table>
        <div class="total-row">
          <span>{{ entityStatsData.length }} total</span>
        </div>
      </div>
    </div>

    <!-- 详细数据表格 -->
    <div class="detail-data-section">
      <!-- 筛选区域 -->
      <div class="filter-section">
        <div class="filter-left">
          <el-dropdown trigger="click" placement="bottom-start">
            <span class="dropdown-trigger">
              <span class="filter-label">详细用量</span>
              <el-icon class="filter-icon"><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu class="column-filter-dropdown">
                <div class="filter-checkboxes">
                  <el-checkbox v-model="filters.all" @change="handleFilterAll">全选</el-checkbox>
                  <el-checkbox v-model="filters.linkId" @change="handleFilterChange">Link</el-checkbox>
                  <el-checkbox v-model="filters.productName" @change="handleFilterChange">产品名</el-checkbox>
                  <el-checkbox v-model="filters.description" @change="handleFilterChange">描述</el-checkbox>
                  <el-checkbox v-model="filters.usage" @change="handleFilterChange">用量</el-checkbox>
                  <el-checkbox v-model="filters.unitPrice" @change="handleFilterChange">单价</el-checkbox>
                  <el-checkbox v-model="filters.totalPrice" @change="handleFilterChange">总价</el-checkbox>
                </div>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

      </div>

      <!-- 详细数据表格 -->
      <div class="detail-table-container">
        <el-table 
          :data="detailTableData" 
          style="width: 100%"
          :show-header="true"
          size="small"
          max-height="500"
          v-loading="detailTableLoading"
        >
          <el-table-column 
            v-if="filters.linkId" 
            prop="linkId" 
            label="Link" 
            align="center" 
            width="150"
          ></el-table-column>
          <el-table-column 
            v-if="filters.productName" 
            label="产品名" 
            min-width="200"
            align="center"
          >
            <template #default="scope">
              {{ scope.row['产品名'] || '' }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="filters.description" 
            label="描述" 
            min-width="300"
            align="center"
            show-overflow-tooltip
          >
            <template #default="scope">
              {{ scope.row['描述'] || '' }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="filters.usage" 
            label="用量" 
            min-width="120"
            align="center"
          >
            <template #default="scope">
              {{ scope.row['用量'] ? scope.row['用量'].toFixed(6) : '0.000000' }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="filters.unitPrice" 
            label="单价" 
            min-width="120" 
            align="center"
          >
            <template #default="scope">
              ${{ scope.row['单价'] ? scope.row['单价'].toFixed(10) : '0.0000000000' }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="filters.totalPrice" 
            label="总价" 
            min-width="120" 
            align="center"
          >
            <template #default="scope">
              ${{ scope.row['总价'] ? scope.row['总价'].toFixed(2) : '0.00' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="table-pagination" v-if="detailTableData.length > 0">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          layout="total, prev, pager, next, jumper"
          size="small"
          @current-change="handlePageChange"
        />
      </div>
    </div>




  </div>
</template>

<script>
import * as echarts from 'echarts'
import { ArrowDown, UploadFilled, ArrowLeft } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { getBillList, getProductAggregation, getPayerList, getBillSumList, getLinkerList, getBillResourceStats } from '@/api/api'

export default {
  name: 'BillDetail',
  components: {
    ArrowDown,
    UploadFilled,
    ArrowLeft
  },
  props: {
    params: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      pieChartInstance: null,
      barChartInstance: null,
      selectedStatType: 'charge',
      // 货币信息
      currentCurrency: {
        symbol: '¥',
        code: 'CNY',
        region: null
      },
      // 实体费用柱状图可见性（默认显示charge）
      entityCostVisibility: {
        charge: true,
        totalCost: false
      },
      // 实体费用数据
      entityCostData: {
        entities: [],
        chargeData: [],
        totalCostData: []
      },
      // payer映射表
      payerMap: new Map(),
      // linker映射表
      linkerMap: new Map(),
      // billType（从路由参数获取）
      billType: 1,
      // 从路由参数获取的数据
      routeParams: {
        month: '',
        nodeType: '',
        nodeId: ''
      },
      // 统计数据
      statsData: {
        charge: '0.00',
        cost: '0.00',
        pieData: []
      },
      // 实体统计数据
      entityStatsData: [],
      // 筛选器状态
      filters: {
        all: true,
        linkId: true,
        productName: true,
        description: true,
        usage: true,
        unitPrice: true,
        totalPrice: true
      },
      // 详细表格数据
      detailTableData: [],
      // 详细表格加载状态
      detailTableLoading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      // 完整数据
      fullDetailData: [],

    }
  },

  computed: {
    currencySymbol() {
      return this.currentCurrency.symbol;
    }
  },

  async mounted() {
    // 优先使用props参数，其次使用路由参数
    if (this.params) {
      this.routeParams.month = this.params.month || ''
      this.routeParams.nodeType = this.params.nodeType || ''
      this.routeParams.nodeId = this.params.nodeId || ''
      this.billType = this.params.billType || 1
    } else {
      this.routeParams.month = this.$route.query.month || ''
      this.routeParams.nodeType = this.$route.query.nodeType || ''
      this.routeParams.nodeId = this.$route.query.nodeId || ''
      this.billType = parseInt(this.$route.query.billType) || 1
    }
    
    console.log('详情页面接收到的参数:', this.routeParams, 'billType:', this.billType)
    
    // 加载payer和linker列表
    await this.loadPayerList()
    await this.loadLinkerList()
    
    // 加载数据
    this.loadBillData()
    
    // 延迟初始化图表，确保DOM完全渲染
    setTimeout(() => {
      this.initPieChart()
      this.initBarChart()
    }, 100)
  },
  beforeUnmount() {
    if (this.pieChartInstance) {
      this.pieChartInstance.dispose()
      this.pieChartInstance = null
    }
    if (this.barChartInstance) {
      this.barChartInstance.dispose()
      this.barChartInstance = null
    }
  },
  methods: {
    // 加载payer列表
    async loadPayerList() {
      try {
        const res = await getPayerList({ page: 1, limit: 999999 })
        if (res.code === 2000 && res.data) {
          const payers = res.data.data || res.data
          payers.forEach(payer => {
            this.payerMap.set(payer.payer_id, payer.name)
          })
          // 设置货币符号
          if (this.routeParams.nodeType === 'payer') {
            const payer = payers.find(p => p.payer_id === this.routeParams.nodeId)
            if (payer) {
              this.setCurrency(payer.region)
            }
          }
        }
      } catch (error) {
        console.error('加载payer列表失败:', error)
      }
    },
    
    // 加载linker列表
    async loadLinkerList() {
      try {
        const res = await getLinkerList({ page: 1, limit: 999999 })
        if (res.code === 2000 && res.data) {
          const linkers = res.data.data || res.data
          linkers.forEach(linker => {
            this.linkerMap.set(linker.link_id, linker.customer_name || linker.name || linker.link_id)
          })
        }
      } catch (error) {
        console.error('加载linker列表失败:', error)
      }
    },
    
    // 加载账单数据
    async loadBillData() {
      if (!this.routeParams.month) return
      
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth() + 1
      const currentMonthStr = `${currentYear}${String(currentMonth).padStart(2, '0')}`
      
      // 解析路由中的月份
      const [year, month] = this.routeParams.month.split('-')
      const queryMonthStr = `${year}${month}`
      
      // 判断是否为当月
      const isCurrentMonth = queryMonthStr === currentMonthStr
      
      try {
        // 加载饼图数据
        await this.loadPieData(isCurrentMonth, queryMonthStr)
        // 加载实体费用数据
        await this.loadEntityCostData(queryMonthStr)
        // 加载实体统计数据
        await this.loadEntityStatsData(queryMonthStr)
        // 加载详细用量数据
        await this.loadResourceStatsData(queryMonthStr)
      } catch (error) {
        console.error('加载账单数据失败:', error)
        ElMessage.error('加载数据失败')
      }
    },
    
    // 加载实体统计数据
    async loadEntityStatsData(month) {
      const params = {
        month: month,
        billType: this.billType
      }
      
      // 根据节点类型构建参数
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        // 修复: 使用agent_record_id参数传递Agent表主键id
        params.agent_record_id = this.routeParams.nodeId
      }
      
      console.log('加载实体统计数据，参数:', params)
      
      try {
        const res = await getBillSumList(params)
        console.log('实体统计数据响应:', res)
        
        if (res.code === 2000 && res.data) {
          this.entityStatsData = Array.isArray(res.data) ? res.data : []
          console.log('实体统计数据已设置:', this.entityStatsData)
        } else {
          console.error('实体统计数据响应异常:', res)
          this.entityStatsData = []
        }
      } catch (error) {
        console.error('加载实体统计数据失败:', error)
        this.entityStatsData = []
      }
    },
    
    // 加载实体费用数据
    async loadEntityCostData(month) {
      const params = { 
        month: month,
        billType: this.billType
      }
      
      // 根据节点类型构建参数
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        // 修复: 使用agent_record_id参数传递Agent表主键id
        params.agent_record_id = this.routeParams.nodeId
      }
      
      console.log('=== 加载实体费用数据 ===', 'params:', params)
      
      try {
        // 使用getBillSumList API获取聚合数据
        const res = await getBillSumList(params)
        
        console.log('getBillSumList响应:', res)
        
        if (res.code === 2000 && res.data) {
          const billSumData = Array.isArray(res.data) ? res.data : []
          
          console.log('BillSum数据条数:', billSumData.length)
          if (billSumData.length > 0) {
            console.log('第一条BillSum数据:', billSumData[0])
          }
          
          // 根据节点类型聚合数据
          const aggregateMap = {}
          
          billSumData.forEach(billSum => {
            let entityKey = ''
            if (this.routeParams.nodeType === 'agent') {
              // agent节点：按payer聚合，显示payer名称
              const payerId = billSum.payerId
              const payerName = billSum.payerName || this.payerMap.get(payerId) || payerId
              entityKey = `${payerName}:`
            } else if (this.routeParams.nodeType === 'payer') {
              // payer节点：按link聚合
              const linkId = billSum.linkId
              const linkName = billSum.linkName || this.linkerMap.get(linkId) || linkId
              entityKey = `Link: ${linkName}`
            } else {
              // link节点：就是自己
              const linkId = billSum.linkId
              const linkName = billSum.linkName || this.linkerMap.get(linkId) || linkId
              entityKey = `Link: ${linkName}`
            }
            
            if (!aggregateMap[entityKey]) {
              aggregateMap[entityKey] = {
                entity: entityKey,
                charge: 0,
                totalCost: 0
              }
            }
            
            // 修复：使用API返回的已处理字段（根据billType选择的）
            aggregateMap[entityKey].charge += Number(billSum.charge) || 0
            aggregateMap[entityKey].totalCost += Number(billSum.totalCost) || 0
          })
          
          console.log('聚合后的数据:', aggregateMap)
          
          // 转换为数组并按当前显示类型降序排列
          const sortedData = Object.values(aggregateMap).sort((a, b) => {
            // 根据当前显示的类型排序
            if (this.entityCostVisibility.charge) {
              return b.charge - a.charge
            } else {
              return b.totalCost - a.totalCost
            }
          })
          
          // 反转数组，使横向柱状图从上到下显示从高到低
          this.entityCostData = {
            entities: sortedData.map(item => item.entity).reverse(),
            chargeData: sortedData.map(item => parseFloat(item.charge.toFixed(2))).reverse(),
            totalCostData: sortedData.map(item => parseFloat(item.totalCost.toFixed(2))).reverse()
          }
        }
        
        // 更新柱状图
        this.$nextTick(() => {
          this.updateBarChart()
        })
      } catch (error) {
        console.error('加载实体费用数据失败:', error)
      }
    },
    
    // 加载饼图数据
    async loadPieData(isCurrentMonth, month) {
      const params = { 
        month: month,
        billType: this.billType  // 修复：传递billType参数
      }
      
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        // 修复: 使用agent_record_id参数传递Agent表主键id
        params.agent_record_id = this.routeParams.nodeId
      }
      
      console.log('加载饼图数据，参数:', params)
      
      try {
        const res = await getProductAggregation(params)
        
        if (res.code === 2000 && res.data) {
          const pieData = res.data.map(item => ({
            name: item.productName,
            charge: item.charge,
            costTotal: item.costTotal
          }))
          
          let totalCharge = 0
          let totalCost = 0
          pieData.forEach(item => {
            totalCharge += item.charge
            totalCost += item.costTotal
          })
          
          this.statsData.charge = totalCharge.toFixed(2)
          this.statsData.cost = totalCost.toFixed(2)
          this.statsData.pieData = pieData
          
          console.log('饼图数据加载成功，总Charge:', this.statsData.charge, '总Cost:', this.statsData.cost)
        }
      } catch (error) {
        console.error('加载饼图数据失败:', error)
      }
      
      this.$nextTick(() => {
        this.updatePieChart()
      })
    },
    
    // 切换统计类型
    switchStatType(type) {
      this.selectedStatType = type
      this.$nextTick(() => {
        this.updatePieChart()
      })
    },
    
    // 初始化饼图
    initPieChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.pieChart
        if (chartDom) {
          this.pieChartInstance = echarts.init(chartDom)
          this.updatePieChart()
        }
      })
    },
    
    // 更新饼图
    updatePieChart() {
      if (!this.pieChartInstance) return
      
      const pieData = this.statsData.pieData || []
      console.log('饼图数据:', pieData, '选中类型:', this.selectedStatType)
      const colors = ['#5ca3db', '#70AD47', '#f7941d', '#ee6c6c', '#9f7aea', '#48c9b0', '#f39c12', '#e74c3c', '#3498db', '#9b59b6']
      
      // 根据选中的类型过滤和映射数据
      const filteredData = pieData
        .filter(item => {
          const value = this.selectedStatType === 'charge' ? item.charge : item.costTotal
          return value > 0
        })
        .map((item, index) => ({
          name: item.name,
          value: this.selectedStatType === 'charge' ? item.charge : item.costTotal,
          itemStyle: { color: colors[index % colors.length] }
        }))
      
      console.log('过滤后的饼图数据:', filteredData)
      const hasData = filteredData.length > 0
      const seriesName = this.selectedStatType === 'charge' ? 'Charge占比' : '实际花费占比'
      
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : ' + this.currencySymbol + '{c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: seriesName,
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: hasData,
              position: 'outside',
              formatter: '{b}\n' + this.currencySymbol + '{c}\n{d}%',
              fontSize: 11
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            data: hasData ? filteredData : []
          }
        ]
      }
      
      this.pieChartInstance.setOption(option)
    },

    // 初始化柱状图
    initBarChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.barChart
        if (chartDom) {
          this.barChartInstance = echarts.init(chartDom)
          this.updateBarChart()
        }
      })
    },
    
    // 更新柱状图
    updateBarChart() {
      if (!this.barChartInstance) return
      
      const entityCount = this.entityCostData.entities.length
      const showLabel = entityCount <= 15
      
      // 只显示当前选中的类型
      const series = this.entityCostVisibility.charge ? [{
        name: 'Charge',
        type: 'bar',
        data: this.entityCostData.chargeData,
        itemStyle: { color: '#409EFF' },
        barWidth: 18,
        label: {
          show: showLabel,
          position: 'right',
          fontSize: 10,
          color: '#409EFF',
          formatter: (params) => this.currencySymbol + params.value
        }
      }] : [{
        name: '实际花费',
        type: 'bar',
        data: this.entityCostData.totalCostData,
        itemStyle: { color: '#ff7f50' },
        barWidth: 18,
        label: {
          show: showLabel,
          position: 'right',
          fontSize: 10,
          color: '#ff7f50',
          formatter: (params) => this.currencySymbol + params.value
        }
      }]
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          left: '20%',
          right: '15%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          data: this.entityCostData.entities,
          axisLabel: {
            color: '#303133',
            fontSize: 10,
            fontWeight: 500
          },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: series
      }
      
      this.barChartInstance.setOption(option, true)
    },
    
    // 切换实体费用显示（互斥）
    toggleEntityCost(type) {
      if (type === 'charge') {
        this.entityCostVisibility.charge = true
        this.entityCostVisibility.totalCost = false
      } else if (type === 'totalCost') {
        this.entityCostVisibility.charge = false
        this.entityCostVisibility.totalCost = true
      }
      // 重新加载数据以重新排序
      const [year, month] = this.routeParams.month.split('-')
      const queryMonthStr = `${year}${month}`
      this.loadEntityCostData(queryMonthStr)
    },

    // 处理全选筛选
    handleFilterAll(value) {
      Object.keys(this.filters).forEach(key => {
        if (key !== 'all') {
          this.filters[key] = value
        }
      })
    },

    // 处理单个筛选项变化
    handleFilterChange() {
      const filterKeys = Object.keys(this.filters).filter(key => key !== 'all')
      const allChecked = filterKeys.every(key => this.filters[key])
      const someChecked = filterKeys.some(key => this.filters[key])
      
      if (allChecked) {
        this.filters.all = true
      } else if (!someChecked) {
        this.filters.all = false
      } else {
        this.filters.all = false
      }
    },



    // 加载资源统计数据（详细用量）
    async loadResourceStatsData(month) {
      console.log('=== 开始加载详细用量数据 ===', 'month:', month)
      
      // 直接从路由参数构建linkIds，不依赖entityStatsData
      let linkIds = []
      
      if (this.routeParams.nodeType === 'link') {
        // link节点：直接使用nodeId
        linkIds = [this.routeParams.nodeId]
      } else if (this.entityStatsData && this.entityStatsData.length > 0) {
        // payer或agent节点：从entityStatsData提取
        linkIds = this.entityStatsData
          .map(item => item.linkId || item.link_id || item.LinkedAccountId)
          .filter(id => id)
      }
      
      console.log('提取的 linkIds:', linkIds)
      
      if (linkIds.length === 0) {
        console.log('❌ 没有提取到 linkId')
        this.detailTableData = []
        this.totalRecords = 0
        return
      }
      
      const params = {
        month: month,
        link_ids: linkIds.join(',')
      }
      
      console.log('请求参数:', params)
      console.log('请求URL:', '/api/bill/resourceStats/')
      
      this.detailTableLoading = true
      try {
        const res = await getBillResourceStats(params)
        console.log('API 响应完整数据:', JSON.stringify(res, null, 2))
        
        console.log('响应code:', res.code)
        console.log('响应data类型:', typeof res.data, 'isArray:', Array.isArray(res.data))
        console.log('响应data长度:', res.data?.length)
        
        if (res.code === 2000) {
          this.fullDetailData = Array.isArray(res.data) ? res.data : []
          this.totalRecords = this.fullDetailData.length
          this.currentPage = 1
          this.updatePageData()
          console.log('✅ 加载成功:', this.detailTableData.length, '条数据')
          console.log('fullDetailData:', this.fullDetailData.length, '条')
          console.log('detailTableData:', this.detailTableData.length, '条')
          if (this.detailTableData.length > 0) {
            console.log('示例数据:', JSON.stringify(this.detailTableData[0], null, 2))
          }
        } else {
          console.error('❌ API 返回错误:', res)
          this.detailTableData = []
          this.totalRecords = 0
        }
      } catch (error) {
        console.error('❌ 请求失败:', error)
        this.detailTableData = []
        this.totalRecords = 0
      } finally {
        this.detailTableLoading = false
      }
    },
    
    // 处理下载
    handleDownload() {
      if (this.detailTableData.length === 0) {
        ElMessage.warning('暂无数据可下载')
        return
      }
      ElMessage.info('下载功能开发中...')
    },
    
    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page
      this.updatePageData()
    },
    
    // 更新分页数据
    updatePageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.detailTableData = this.fullDetailData.slice(start, end)
    },
    
    // 设置货币信息
    setCurrency(region) {
      if (region === 'cn') {
        this.currentCurrency = {
          symbol: '¥',
          code: 'CNY',
          region: 'cn'
        };
      } else if (region === 'global') {
        this.currentCurrency = {
          symbol: '$',
          code: 'USD',
          region: 'global'
        };
      } else {
        this.currentCurrency = {
          symbol: '$',
          code: 'USD',
          region: null
        };
      }
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-detail-page {
  min-height: 100vh;
  background: #F5F5F7;
  padding: 0;
  margin: 0;
  padding-bottom: 60px;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

/* 顶部工具栏 */
.top-toolbar {
  background: #FFFFFF;
  padding: 16px 20px;
  border-bottom: 1px solid #E5E5EA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.breadcrumb {
  font-size: 14px;
  color: #1D1D1F;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 12px;
  
  .back-button {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #1D6FE8;
    font-size: 14px;
    padding: 4px 8px;
    border-radius: 6px;
    transition: all 0.15s;
    
    &:hover {
      background: #EBF2FD;
      color: #1860cc;
    }
    
    .el-icon {
      font-size: 16px;
    }
  }
  
  .breadcrumb-text {
    position: relative;
    padding-left: 12px;
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background: #1D6FE8;
      border-radius: 2px;
    }
  }
}

.date-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .el-button {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 4px;
    
    &.el-button--primary {
      background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
      border: none;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
      
      &:hover {
        background: linear-gradient(135deg, #66b3ff 0%, #409eff 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.4);
      }
    }
  }
}

.date-separator {
  margin: 0 5px;
  color: #909399;
  font-size: 12px;
}

/* 主要内容区域 */
.main-content {
  padding: 20px 0;
  max-width: 1400px;
  margin: 0 auto;
}

/* 图表区域整体容器 */
.charts-section {
  display: flex;
  gap: 0;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  overflow: hidden;
  margin-bottom: 20px;
}

/* 左侧图表区域 */
.left-charts {
  flex: 1;
  display: flex;
  width: 50%;
  flex-direction: column;
}

.chart-item {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  width: 100%;
  min-height: 400px;
}

.pie-chart-header {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #1D1D1F;
  padding: 16px 0 0 0;
}

.pie-chart {
  height: 300px;
  min-height: 300px;
  padding: 10px 20px;
  width: 100%;
}

.pie-info {
  padding: 16px 20px 20px;
  border-top: 1px solid #E5E5EA;
  background: #FAFAFA;
}

.pie-stats {
  display: flex;
  gap: 12px;
  justify-content: center;
  
  .stat-item {
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s;
    position: relative;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
    
    &.active::after {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border: 2px solid;
      border-radius: 10px;
      pointer-events: none;
    }
    
    &.charge {
      border: 1px solid #1D6FE8;
      background: #EBF2FD;
      
      &.active::after { border-color: #1D6FE8; }
      .stat-value { color: #1D6FE8; }
    }
    
    &.cost {
      border: 1px solid #FF9500;
      background: #FFF8EC;
      
      &.active::after { border-color: #FF9500; }
      .stat-value { color: #FF9500; }
    }
    
    .stat-label {
      font-size: 12px;
      color: #6E6E73;
      margin-bottom: 4px;
    }
    
    .stat-value {
      font-size: 16px;
      font-weight: 600;
    }
  }
}

/* 右侧柱状图区域 */
.right-content {
  width: 50%;
  flex: 1;
  background: transparent;
  border: none;
  border-left: 1px solid #E5E5EA;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.entity-cost-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #E5E5EA;
  background: #FAFAFA;
  
  .entity-cost-title {
    font-size: 14px;
    font-weight: 500;
    color: #1D1D1F;
  }
  
  .entity-cost-actions {
    display: flex;
    gap: 8px;
  }
}

.bar-chart-container {
  flex: 1;
  width: 100%;
  position: relative;
}

.bar-chart {
  width: 100%;
  height: 100%;
  min-height: 350px;
  padding: 20px;
}

/* 实体统计表格样式 */
.entity-stats-section {
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  overflow: hidden;
  max-width: 1400px;
  margin: 0 auto 20px;
}

.section-header {
  padding: 16px 20px;
  background: #FAFAFA;
  border-bottom: 1px solid #E5E5EA;
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: #1D6FE8;
    border-radius: 2px;
  }
  
  h3 {
    margin: 0;
    padding-left: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #1D1D1F;
  }
}

.stats-table-container {
  padding: 0;
}

.total-row {
  padding: 12px 20px;
  font-size: 12px;
  color: #6E6E73;
  border-top: 1px solid #E5E5EA;
  background: #FAFAFA;
  text-align: left;
  font-weight: 500;
}

/* 详细数据表格样式 */
.detail-data-section {
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  overflow: hidden;
  max-width: 1400px;
  margin: 0 auto 20px;
}

.filter-section {
  padding: 16px 20px;
  background: #FAFAFA;
  border-bottom: 1px solid #E5E5EA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: #1D6FE8;
    border-radius: 2px;
  }
}

.filter-left {
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 12px;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.15s;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  
  &:hover {
    border-color: #1D6FE8;
    color: #1D6FE8;
  }
}

.filter-label {
  font-size: 13px;
  color: #1D1D1F;
  font-weight: 500;
}

.filter-icon {
  color: #AEAEB2;
  font-size: 12px;
}

.column-filter-dropdown {
  padding: 12px;
  min-width: 220px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  border: 1px solid #E5E5EA;
}

.filter-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-table-container {
  padding: 0;
}

.table-pagination {
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #E5E5EA;
  background: #FAFAFA;
}

/* Element Plus 表格样式优化 */
:deep(.el-table) {
  font-size: 12px;
  --el-table-border-color: #E5E5EA;
  --el-table-header-bg-color: #FAFAFA;
  --el-table-row-hover-bg-color: #F5F8FF;
}

:deep(.el-table th) {
  background: #FAFAFA;
  font-weight: 500;
  color: #6E6E73;
  font-size: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #E5E5EA;
}

:deep(.el-table td) {
  padding: 10px 0;
  font-size: 12px;
  color: #1D1D1F;
  border-bottom: 1px solid #F2F2F7;
}

:deep(.el-table .cell) {
  padding: 0 12px;
  line-height: 1.5;
}

:deep(.el-table tr:hover > td) {
  background: #F5F8FF;
}

:deep(.el-table--border) {
  border: none;
}

:deep(.el-table--border::after) {
  display: none;
}

:deep(.el-table tbody tr:last-child td) {
  border-bottom: none;
}

/* 复选框样式 */
:deep(.el-checkbox) {
  font-size: 12px;
  margin-bottom: 2px;
  
  .el-checkbox__label {
    color: #1D1D1F;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .charts-section {
    flex-direction: column;
  }
  
  .left-charts {
    width: 100%;
  }
  
  .right-content {
    border-left: none;
    border-top: 1px solid #e8eaec;
  }
}

@media (max-width: 768px) {
  .top-toolbar {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .main-content {
    padding: 10px;
  }
  
  .entity-stats-section,
  .detail-data-section {
    margin: 0 10px 10px;
  }
  }
  

  </style>  